import { render, staticRenderFns } from "./BlogTags.vue?vue&type=template&id=0816f816&"
import script from "./BlogTags.vue?vue&type=script&lang=js&"
export * from "./BlogTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports